import React, { createContext, useContext, useEffect, useState } from "react";

interface GlobalNode {
	is_processing: boolean;
	setIsProcessing: Function;
}
const GlobalContext = createContext({} as GlobalNode);

interface Props {}
export const GlobalProvider: React.FC<Props> = ({ children }) => {
	const [is_processing, setIsProcessing] = useState(false);

	return (
		<GlobalContext.Provider
			value={{
				is_processing,
				setIsProcessing,
			}}
		>
			{children}
		</GlobalContext.Provider>
	);
};

export const useGlobal = () => useContext(GlobalContext);
